import { InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { Colors } from "Components/Layout/Themes/Colors";
import { Resources, useResource } from "Translations/Resources";
import { useEffect, useRef, useState } from "react";

const RESOURCES = Resources.Components.Transactions;
const DEBOUNCE_MS = 300;

type Props = {
  value?: string;
  onChange: (value?: string) => void;
};

export const SearchInput = ({ value = "", onChange }: Props) => {
  const [localValue, setLocalValue] = useState(value);
  const { t } = useResource();

  // Store onChange in a ref to avoid it as a dependency
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  // Debounce the onChange callback
  useEffect(() => {
    const timer = setTimeout(() => {
      if (localValue !== value) {
        onChangeRef.current(localValue || undefined);
      }
    }, DEBOUNCE_MS);

    return () => clearTimeout(timer);
  }, [localValue, value]);

  return (
    <TextField
      value={localValue}
      onChange={({ target }) => {
        setLocalValue(target.value.toUpperCase());
      }}
      placeholder={t(RESOURCES.Search.Placeholder)}
      size="small"
      fullWidth
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: Colors.TextLight }} />
            </InputAdornment>
          ),
          sx: {
            borderRadius: "20px",
            backgroundColor: Colors.MediumGrey,
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              border: `1px solid ${Colors.PrimaryMain}`,
            },
          },
        },
      }}
    />
  );
};
